import { getFragmentData } from "../../../generated"
import { PhoneNumberFragment } from "../../../generated/graphql"
import { IDENTITY_NORTH_AMERICAN_PHONE_NUMBER_FRAGMENT } from "./telephoneNumber"

export const getPhoneNumber = (
    phoneNumber: PhoneNumberFragment | null | undefined
): string | null => {
    if (!phoneNumber) {
        return null
    }

    switch (phoneNumber?.__typename) {
        case "NorthAmericanPhoneNumber": {
            const northAmericanPhoneNumber = getFragmentData(
                IDENTITY_NORTH_AMERICAN_PHONE_NUMBER_FRAGMENT,
                phoneNumber
            )
            return northAmericanPhoneNumber?.formatted
        }
        default:
            return phoneNumber?.e164
    }
}
